import React from 'react';
import styles from './NewsCard.module.scss';
import Text from '../text/Text';
import HtmlTag from '../../molecule/htmlTag/HtmlTag';
import formatDate from '../../../app/helpers/formateDate';
import { Link, useNavigate } from 'react-router-dom';
import useIsRtl from '../../../app/helpers/isRtl';
import getCookie from '../../../app/helpers/getCookie';
import { sanitizeAndValidateUrl } from '../../../app/helpers/sanitizeAndValidateUrl';
const arrowDown = '/assets/svg/cards/Arrow_Down.svg';
const lineSvg = '/assets/svg/line.svg';
const clockSvg = '/assets/svg/cards/clock.svg';
const defaultImage = '/images/defaultImage.png';

const NewsCard = ({
  id,
  image,
  date,
  title,
  description,
  type,
  gallery = { images: [] },
  isCLickable,
  variant = 'default',
  isGrid,
  className = '',
  imageWrapper = '',
}) => {
  const navigate = useNavigate();
  const isEnglish = getCookie('googtrans')?.includes('/ar/en');

  const isRtl = useIsRtl();
  const sanitizedImageUrl = sanitizeAndValidateUrl(image);
  const handleError = (e) => {
    e.target.src = defaultImage;
  };
  const handleNavigate = () => {
    navigate(`/news-and-events/news/${type}-${id}`);
  };
  return (
    <div
      className={`${styles.card} ${isCLickable ? styles['clickable-card'] : ''} ${styles[variant] ?? ''} ${className}`}
      onClick={isCLickable ? handleNavigate : () => {}}
    >
      <div className={`${styles.imageWrapper} ${imageWrapper}`}>
        {type === 'events' && date ? (
          <div className={`${styles.tag} ${isRtl ? styles['rtl-tag'] : ''}`}>
            <img src={clockSvg} alt="" />
            <Text
              title={
                new Date(date) < new Date()
                  ? 'common.date_expired'
                  : formatDate(date)
              }
              variant="text-regular-12"
              className={`${styles.eventDate}`}
              style={{ direction: 'ltr' }}
            />
          </div>
        ) : null}
        <img
          src={sanitizedImageUrl || defaultImage}
          alt={''}
          className={styles.image}
          onError={handleError}
          loading="lazy"
          decoding="async"
        />
      </div>

      <div className={`${styles.content} ${isRtl ? styles.rtl : ''}`}>
        {(type === 'events' || type === 'news') && date && (
          <Text
            title={formatDate(date)}
            variant="text-regular-16"
            className={`${styles.date} notranslate`}
            style={{ direction: 'ltr' }}
          />
        )}
        {type === 'media' && gallery?.images?.length > 0 ? (
          <div className={`${styles.mediaCount} `}>
            <Text
              title={gallery.images.length}
              variant="text-regular-12"
              className={`${styles.date} notranslate`}
              style={{ direction: 'ltr' }}
            />
            <Text
              title={
                isRtl && !isEnglish
                  ? 'common.photo'
                  : gallery?.images?.length === 1
                    ? 'photo'
                    : 'photos'
              }
              variant="text-regular-12"
              className={styles.date}
            />
          </div>
        ) : null}
        <div
          className={`${styles['title']} ${type === 'events' || type === 'media' ? styles['event-title'] : ''}`}
        >
          <Text
            title={title}
            variant="text-bold-italic-16"
            color="black"
            maxLines={2}
          />
        </div>
        <div className={`${styles['line-container']} `}>
          <img src={lineSvg} className={styles.line} alt="" />
        </div>
        {type !== 'media' ? (
          <>
            <HtmlTag
              title={description}
              variant="text-regular-12"
              color="#7F7F7F"
              maxLines={3}
            />
            {variant !== 'faded' ? (
              <Link
                to={`/news-and-events/news/${type}-${id}`}
                className={`${styles.readMore} `}
              >
                <Text
                  title="common.read_more"
                  variant="text-bold-italic-16"
                  className={styles.link}
                  svg={arrowDown}
                  svgPosition="right"
                  svgStyle={{ marginLeft: '5px' }}
                />
              </Link>
            ) : null}
          </>
        ) : null}
      </div>
    </div>
  );
};

export default NewsCard;
